import type {
  CreateFeedbackInput,
  FeedbackResponse,
  LessonFeedback,
  RatingSummary,
} from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useLessonFeedback(lessonId: string) {
  return useQuery({
    queryKey: ['lessons', lessonId, 'feedback'],
    queryFn: () => api.get<FeedbackResponse[]>(`/api/lessons/${lessonId}/feedback`),
    enabled: !!lessonId,
  })
}

export function useLessonRating(lessonId: string) {
  return useQuery({
    queryKey: ['lessons', lessonId, 'rating'],
    queryFn: () => api.get<RatingSummary>(`/api/lessons/${lessonId}/feedback/rating`),
    enabled: !!lessonId,
  })
}

export function useMyLessonFeedback(lessonId: string) {
  return useQuery({
    queryKey: ['lessons', lessonId, 'feedback', 'me'],
    queryFn: () => api.get<LessonFeedback | null>(`/api/lessons/${lessonId}/feedback/me`),
    enabled: !!lessonId,
  })
}

export function useSubmitFeedback() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ lessonId, data }: { lessonId: string; data: CreateFeedbackInput }) =>
      api.post(`/api/lessons/${lessonId}/feedback`, data),
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ['lessons', variables.lessonId, 'feedback'] })
      qc.invalidateQueries({ queryKey: ['lessons', variables.lessonId, 'rating'] })
    },
  })
}
